import React from 'react';
import { FaEnvelope } from 'react-icons/fa';
import Styles from './Contact.module.css';

function Contact() {
    return (
        <>
            <div data-testid="spacer" style={{ height: '100px', backgroundColor: '#f0f0f0' }}></div> { }
            <div data-testid="container" className={Styles.container}>
                <div data-testid="info" className={Styles.info}>
                    <h3> CONTATO</h3>
                    <div className={Styles.subtitle}> Entre em contato </div>

                    <div className={Styles.contactDetail}>
                        <FaEnvelope data-testid="envelope-icon" className={Styles.icon} size={20} color='#fff' />
                        <p> les@prp.uespi </p> <br />
                    </div>
                </div>
                <div data-testid="contactForm" className={Styles.contactForm}>
                    <form action="#" method='post'>
                        <div className={Styles.inputGroup}>
                            <input type="text" name="name" id="name" placeholder="Digite seu nome" required />
                            <input type="text" name="email" id="email" placeholder="Digite seu email" required />
                        </div>
                        <textarea name="mensagem" id="mensagem" placeholder="Digite uma mensagem" required />
                        <input type='submit' id='sendEmail' value='Enviar mensagem' className={Styles.submitButton} />
                    </form>
                </div>
            </div>
        </>
    );
}

export default Contact;
